import Script from 'next/script';

import { assetUrl } from '@/utils/assetUrl';
import { getDeviceAdId } from '@/utils/getDeviceAdId';

import { Keys, NetworkCallback, System } from '../index';

declare global {
  interface Window {
    PalmSystem: any;
    webOSSystem: any;
  }
}

function registeredKeys() {
  return {
    UP: 38,
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    OK: 13,
    BACK: 461,
  };
}
type onConnectionSuccessResponse = {
  wired: any;
  wifi: any;
  isInternetConnectionAvailable: boolean;
  returnValue: boolean;
  wifiDirect: any;
};

type getIdSuccessResponse = {
  idList: Array<{
    idType: string;
    idValue: string;
  }>;
  returnValue: string;
};

type getIdErrorResponse = {
  returnValue: boolean;
  errorCode: number;
  errorText: string;
};

type onConnectionErrorResponse = {
  returnValue: boolean;
  errorCode: number;
  errorText: string;
};

const getDeepLinkId = () => {
  const launchParams =
    window?.PalmSystem?.launchParams ?? window?.webOSSystem?.launchParams;
  if (launchParams) {
    const params = JSON.parse(launchParams);
    if (params.contentTarget) {
      return params.contentTarget;
    }
  }
  return null;
};

export const system: System = {
  id: 'lg',
  init: () => {
    console.log('LG System');
  },
  version: () => 'lg.1.0.0',
  script: () => {
    return (
      <>
        <Script strategy="beforeInteractive" src={assetUrl('/lg/lib/webostv.js')} />
        <Script strategy="beforeInteractive" src={assetUrl('/lg/lib/webostv-dev.js')} />
      </>
    );
  },
  keyThrottleDelay: 100,
  key: (keyboardEvent) => {
    const deviceKeys = registeredKeys();
    switch (keyboardEvent.keyCode) {
      case deviceKeys.UP:
        return Keys.UP;
      case deviceKeys.DOWN:
        return Keys.DOWN;
      case deviceKeys.LEFT:
        return Keys.LEFT;
      case deviceKeys.RIGHT:
        return Keys.RIGHT;
      case deviceKeys.OK:
        return Keys.OK;
      case deviceKeys.BACK:
        return Keys.BACK;
      default:
        return Keys.UNKNOWN;
    }
  },

  getDeviceId: async () => {
    try {
      let deviceId: string = await getDeviceId();
      console.log('Device ID:', deviceId);
      return deviceId;
    } catch (err) {
      console.error('Failed to fetch Device Id');
      return '';
    }
  },

  getErrorCodePrefix: () => 'B',
  closeApp: () => {
    (window as any)?.webOS?.platformBack();
  },
  getDeviceAdId: async () => {
    return getDeviceAdId();
  },
  getAdIdType: async () => {
    return 'lgudid';
  },
  getIsLimitedAdTracking: async () => {
    // TODO: Determine if LG ad tracking is enabled
    return true;
  },
  monitorConnectionStatus: (callback: NetworkCallback) => {
    const subscriptionHandle = (window as any)?.webOS.service.request(
      'luna://com.palm.connectionmanager',
      {
        method: 'getStatus',
        parameters: { subscribe: true },
        onSuccess: function (res: { isInternetConnectionAvailable: boolean }) {
          callback(res.isInternetConnectionAvailable);
        },
      }
    );

    return () => {
      subscriptionHandle.cancel();
    };
  },
  hasPointer: true,
  initDeepLink: (handleDeepLink: (contentId: string) => void) => {
    const contentId = getDeepLinkId();
    if (contentId) {
      handleDeepLink(contentId);
    }

    const handleRelaunch = () => {
      const contentId = getDeepLinkId();
      if (contentId) {
        handleDeepLink(contentId);
      }
    };
    document.addEventListener('webOSRelaunch', handleRelaunch);

    return () => {
      document.removeEventListener('webOSRelaunch', handleRelaunch);
    };
  },
  getDeepLinkId,
};

//helper function
function getDeviceId(): Promise<string> {
  return new Promise((resolve, reject) => {
    try {
      const networkAPI = (window as any).webOS;

      networkAPI.service.request('luna://com.webos.service.sm', {
        method: 'deviceid/getIDs',
        parameters: {
          idType: ['LGUDID'],
        },

        onSuccess: function (inResponse: getIdSuccessResponse) {
          console.log('Result: ' + JSON.stringify(inResponse));
          resolve(inResponse.idList[0].idValue);
          // To-Do something
        },

        onFailure: function (inError: getIdErrorResponse) {
          console.log('Failed to get system ID information');
          console.log('[' + inError.errorCode + ']: ' + inError.errorText);
          reject(inError.errorText);
          // To-Do something
        },
      });
    } catch (e) {
      reject('Failed to fetch Device Id');
    }
  });
}
